import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { PM_PROVIDERS } from 'common/constants/constants';
import useProjectConfiguration from 'common/fetchHooks/useProjectConfiguration';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { METHOD_NAMES } from './consts';
import {
  checkForComponentsIncludeInConfiguration,
  configurationToSelectedFilters,
  configurationToSelectedMethod
} from './createEditProjectModal.service';
import useNameValidator from './useNameValidator';
import useSettingsService from 'components/hooks/useSettingsService';
import { FILTER_TYPES } from 'common/constants/filters';

const useCreateEditProjectModal = (projectName, projectId, pmSensor = {}) => {
  const [
    isSkipProjectsBoardSelectionFFEnabled,
    setIsSkipProjectsBoardSelectionFFEnabled
  ] = useState(false);
  const { getSettingOrDefinitionValue } = useSettingsService();
  const [selectedFilters, setSelectedFilters] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState('');
  const [curProjectName, setCurProjectName] = useState(projectName);
  const [excludeIterations, setExcludeIterations] = useState([]);
  const [includeIterations, setIncludeIterations] = useState([]);

  const validateForm = () => {
    let isFormValid = true;

    switch (pmSensor?.sensor_id) {
      case PM_PROVIDERS.JIRA:
        const isBoardSelected = !_.isEmpty(selectedFilters[FILTER_TYPES.BOARD]);
        isFormValid = isSkipProjectsBoardSelectionFFEnabled || isBoardSelected;
        break;
      case PM_PROVIDERS.AZURE_BOARDS:
        const isTeamAreasSelected = !_.isEmpty(
          selectedFilters[FILTER_TYPES.AZURE_BOARDS_PROJECT_TEAM_AREAS]
        );
        isFormValid = isTeamAreasSelected;
        break;
      default:
        break;
    }

    setIsFormValid(isFormValid);
  };

  const onDeleteFilter = (filterType, id) => {
    const currentSelectedFilters = _.get(selectedFilters, filterType, []);
    const newSelectedFilters = currentSelectedFilters.filter(
      item => item.id !== id
    );
    const filtersAfterDelete = {
      ..._.omit(selectedFilters, filterType),
      ...{ [filterType]: newSelectedFilters }
    };
    setSelectedFilters(filtersAfterDelete);
  };

  useEffect(() => {
    const skipSelection = getSettingOrDefinitionValue({
      name: FEATURE_FLAGS_NAMES.skipProjectsBoardSelection
    });

    if (skipSelection) {
      setIsSkipProjectsBoardSelectionFFEnabled(skipSelection);
    }
  }, []);

  const { configuration, upsertConfiguration, loadingConfiguration } =
    useProjectConfiguration({
      name: projectName,
      id: projectId
    });

  const nameValidator = useNameValidator(projectName, curProjectName);

  useEffect(() => {
    validateForm();
  }, [selectedFilters, selectedMethod]);

  useEffect(() => {
    const defaultMethod = METHOD_NAMES[Object.keys(METHOD_NAMES)[0]];
    const configurationWithComponents =
      checkForComponentsIncludeInConfiguration(configuration || {});
    setSelectedFilters(
      configurationToSelectedFilters(configurationWithComponents || {})
    );
    setSelectedMethod(
      configurationToSelectedMethod(configurationWithComponents || {}) ||
        defaultMethod.type
    );
    setIncludeIterations(_.get(configuration, 'sprint_includes', ['^.*$']));
    setExcludeIterations(_.get(configuration, 'sprint_excludes', []));
  }, [configuration]);

  return {
    selectedFilters,
    setSelectedFilters,
    selectedMethod,
    setSelectedMethod,
    curProjectName,
    setCurProjectName,
    nameValidator,
    configuration,
    upsertConfiguration,
    isFormValid,
    setIsFormValid,
    isSkipProjectsBoardSelectionFFEnabled,
    includeIterations,
    setIncludeIterations,
    excludeIterations,
    setExcludeIterations,
    loadingConfiguration,
    onDeleteFilter
  };
};

export default useCreateEditProjectModal;
